export default __webpack_public_path__ + "static/media/acceso-camara-mac-2.45cbc34d.svg";